var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_c('p',{staticClass:"decode-result"},[_vm._v("Last result: "),_c('b',[_vm._v(_vm._s(_vm.result))])]),_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }